var version = {
    "name":      "dativery",
    "buildDateCode": "20260428-150741",
    "buildDate": "Tue Apr 28 2026 15:07:41 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260428-150741",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;